
import { defineComponent, markRaw } from 'vue';
import JWTUtils from '@/utils/JWTUtils';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import Utils from '@/utils/QSUtils';

import ConfigureSettingsModal from '@/components/3.6/modals/ConfigureSettings.vue';
import MLSImportModal from '@/components/3.6/modals/MLSImport.vue';
import AddManualCompModal from '@/components/3.6/modals/AddManualComp.vue';
import { useStore } from 'vuex';
import { computed } from '@vue/runtime-core';
import { Actions, miscSettingsStore } from '@/store';
import LogUsageManager from '@/manager/LogUsageManager';
import { makeGettersWatchable } from '@/utils/StoreWatch';
import _ from 'lodash';

export default defineComponent({
    components: { ConfigureSettingsModal, MLSImportModal },
    data() {
        return {
            userName: '',
            uadVersion: 2.6,
            modalConfigureSettings: {
                show: false,
                component: markRaw(ConfigureSettingsModal),
                defaultTabIdx: 0
            },
            modalAddManualComp: {
                show: false,
                component: markRaw(AddManualCompModal)
            }
        };
    },

    setup() {
        const store = useStore();
        const miscSettings = makeGettersWatchable(miscSettingsStore);
        
        return { 
            store, 
            miscSettings
         };
    },
    mounted() {
        this.userName = this.getUserName();
        const UADVersion = computed(() => this.miscSettings.UADVersion);
        this.uadVersion = _.cloneDeep(UADVersion.value);
    },
    methods: {
        getUserName(): string {
            const accessToken = theLocalStorageUtils.get(LocalStorageKeys.qsAccessToken);
            const fn = JWTUtils.getValue(accessToken ?? '', 'fn');
            const ln = JWTUtils.getValue(accessToken ?? '', 'ln');

            let name = 'User Settings';
            if (fn && ln) {
                name = `${fn} ${ln.charAt(0)}.`;
            }
            return name;
        },
        launchConfigureSettingsModal() {
            this.modalConfigureSettings.show = true;
            this.modalConfigureSettings.defaultTabIdx = 0;
        },
        launchAddManualCompModal() {
            this.modalAddManualComp.show = true;
        },
        launchMLSImportModal() {
            (this as any).eventBus.emit('modalMLSImport');
        },
        onlyShowReportRows(value: boolean) {
            this.store.dispatch(Actions.CompAddressesV36.OnlyShowReportRows, value);
            // if (value) {
            //     LogUsageManager.enabledShowReportRows();
            // } else {
            //     LogUsageManager.disabledShowReportRows();
            // }
        },
        onlyShowDiscrepancyRows(value: boolean) {
            this.store.dispatch(Actions.CompAddressesV36.OnlyShowDiscrepancyRows, value);
            if (value) {
                LogUsageManager.enabledShowDataDiscrepancies();
            } else {
                LogUsageManager.disabledShowDataDiscrepancies();
            }
        },
        launchUserTutorial() {
            LogUsageManager.revisitedFirstTimeTutorial();

            (this as any).eventBus.emit('launchUserTutorial');
        }
    }
});
